import { Box, Divider, Typography } from "@mui/material";
import HeaderBox from "../../../components/shared/boxes/HeaderBox";
import ContainerBox from "../../../components/shared/boxes/ContainerBox";
import InvoiceMenu from "../new/InvoiceMenu";

const InvoiceNewContainer = () => {
    return (
        <>
            <Box sx={{ bgcolor: 'background.header' }}>
                <HeaderBox>
                    <Typography variant="h3">Criar fatura</Typography>
                </HeaderBox>
            </Box>
            <Divider />
            <Box sx={{ bgcolor: 'background.default' }}>
                <ContainerBox>
                    <InvoiceMenu />
                </ContainerBox>
            </Box>
        </>
    );
};

export default InvoiceNewContainer;